import React from 'react';
import { useRoute } from '@react-navigation/native';
import { WebviewScreenLayout } from 'shared/src/component';
import { useWebviewUri } from 'shared/src/hooks';
import { WEB_ROUTE_PATHS } from 'shared/src/webRoutePaths';

/** `/cart` 뒤에 딸려오는 쿼리 파라미터(예: from=CARTICON). 그대로 웹뷰 URL 로 이어붙인다. */
type CartRouteParams = Record<string, string | undefined>;

/**
 * 장바구니 화면.
 *
 * `/cart` 를 전용 화면으로 두는 이유: 범용 `WebViewScreen` 으로 열면 목적지 URL 이 `url`
 * params 문자열로 들어가서 react-navigation 이 만드는 주소가 `/cart` 가 아니게 된다
 * (`?url=https%3A%2F%2F...%2Fcart` 가 붙는 형태). Navigator 에 `path: /cart` 로 등록해
 * 주소를 `/cart` 로 유지하고, 뒤에 딸린 파라미터는 그대로 승계한다.
 */
export const CartScreen: React.FC = () => {
  const route = useRoute();
  const uri = useWebviewUri(
    WEB_ROUTE_PATHS.Cart,
    (route.params ?? {}) as CartRouteParams,
  );

  return <WebviewScreenLayout title={'장바구니'} uri={uri} />;
};
